module.exports = __webpack_public_path__ + "static/media/fly0002.e6614f55.webp";